export const state = {
  employees: [],
  drivers: [],
  systemEmployee: []
}
export default state



// WEBPACK FOOTER //
// ./src/vuex/modules/employees/state.js